const { map, cloneDeep } = require('lodash');
const { formatText } = require('core/i18n').i18n;

const typeOfRoads = require('constants/typeOfRoadsList');

const dataTypes = {
    CRU: 'CRU',
    REG_DATA: 'REG_DATA',
    ADDRESS: 'ADDRESS',
    IGNORE: 'IGNORE'
};

const text = () => {
    return {
        TITLE: formatText('mortgageRequestEstates-titleInfo'),
        SUMMARY: formatText('mortgageRequestEstates-summaryInfo'),
        LIVING_PLACE: {
            SUBTITLE: formatText('mortgageRequestEstates-livingPlaceSubtitleInfo'),
            ESTATE_ADITIONAL_INFO: formatText('mortgageRequestEstates-livingPlaceAditionalInfo'),
            SUMMARY: formatText('mortgageRequestEstates-livingPlaceAditionalInfoSummary'),
            OPTIONS: {
                [dataTypes.ADDRESS]: formatText('mortgageRequestEstates-livingPlaceNoAddInfo'),
                [dataTypes.CRU]: formatText('mortgageRequestEstates-livingPlaceAddRegCode'),
                [dataTypes.REG_DATA]: formatText('mortgageRequestEstates-livingPlaceAddRegData')
            }
        },
        ANOTHER_ESTATES: {
            DELETE: formatText('mortgageRequestEstates-anotherEstatesDelete'),
            TITLE: formatText('mortgageRequestEstates-anotherEstatesTitle'),
            SUBTITLE: formatText('mortgageRequestEstates-anotherEstatesSubtitle'),
            BTN: {
                ADD_STORAGE_ROOM: formatText('mortgageRequestEstates-anotherEstatesBtnAddStorageRoomTitle'),
                ADD_GARAGE: formatText('mortgageRequestEstates-anotherEstatesBtnAddGarageTitle')
            },
            QUESTITON: formatText('mortgageRequestEstates-anotherEstatesQuestion'),
            ANSWER: {
                POSITIVE: formatText('mortgageRequestEstates-anotherEstatesAnswerPositive'),
                NEGATIVE: formatText('mortgageRequestEstates-anotherEstatesAnswerNegative'),
            },
            DETAIL_INFO: formatText('mortgageRequestEstates-anotherEstatesDetailInfo'),
            ADDITIONAL: {
                IS_PART: formatText('mortgageRequestEstates-anotherEstatesAdditionalIsPart'),
                IS_NOT_PART: formatText('mortgageRequestEstates-anotherEstatesAdditionalIsNotPart'),
                SELECT_OPTION: formatText('mortgageRequestEstates-anotherEstatesAdditionalSelectOption'),
                OPTIONS: {
                    CRU: formatText('mortgageRequestEstates-anotherEstatesAdditionalOptionCru'),
                    REG_DATA: formatText('mortgageRequestEstates-anotherEstatesAdditionalOptionRegData'),
                    ADDRESS: formatText('mortgageRequestEstates-anotherEstatesAdditionalOptionAddress'),
                },
                SAME_ADDRESS: formatText('mortgageRequestEstates-anotherEstatesAdditionalSameAddress'),
            }
        },
        LABEL: {
            TYPE_OF_ROAD: formatText('mortgageRequestEstates-addressTypeOfRoad'),
            ROAD_NAME: formatText('mortgageRequestEstates-addressRoadName'),
            NUMBER_STREET: formatText('mortgageRequestEstates-addressNumberStreet'),
            ANOTHER: formatText('mortgageRequestEstates-addressAnother'),
            PROVINCE: formatText('mortgageRequestEstates-addressProvince'),
            POPULATION: formatText('mortgageRequestEstates-addressPopulation'),
            POSTAL_CODE: formatText('mortgageRequestEstates-addressPostalCode'),
            REGISTER_NAME: formatText('mortgageRequestEstates-regDataRegisterName'),
            ESTATE_NUMBER: formatText('mortgageRequestEstates-regDataEstateNumber'),
            NUMBER_LABEL: formatText('mortgageRequestEstates-anotherEstatesAdditionalNumberLabel'),
            SECTION: formatText('mortgageRequestEstates-regDataEstateSection'),
            BOOK: formatText('mortgageRequestEstates-regDataEstateBook'),
            VOLUME: formatText('mortgageRequestEstates-regDataEstateVolume'),
            FOLIO: formatText('mortgageRequestEstates-regDataEstateFolio'),
            STORAGE_ROOM: formatText('mortgageRequestEstates-infoPageAnotherEstatesIncludedStorageRoom', ['']),
            STORAGE_ROOMS: formatText('mortgageRequestEstates-infoPageAnotherEstatesIncludedStorageRoom', ['s']),
            GARAGE: formatText('mortgageRequestEstates-garage'),
            BACK: formatText('common-back'),
            SAVE: formatText('common-save')
        },
        MESSAGES: {
            REQUIRED: formatText('mortgageRequestEstates-inputRequired')
        },
        INFO_PAGE: {
            TEXT_1: formatText('mortgageRequestEstates-infoPageText1'),
            LIVING_DATA: formatText('mortgageRequestEstates-infoPageLivingData'),
            ADDRESS: formatText('mortgageRequestEstates-infoPageAddress'),
            ANOTHER_ESTATES: formatText('mortgageRequestEstates-infoPageAnotherEstates'),
            INCLUDED_ESTATES: formatText('mortgageRequestEstates-infoPageAnotherEstatesIncluded'),
            GARAGE: formatText('mortgageRequestEstates-infoPageAnotherEstatesIncludedGarage', ['']),
            GARAGES: formatText('mortgageRequestEstates-infoPageAnotherEstatesIncludedGarage', ['s']),
            ANOTHER_ESTATES_NOTE: formatText('mortgageRequestEstates-infoPageAnotherEstatesNote')
        }
    }
};

const TYPE_OF_ROADS = map(typeOfRoads, (label, value) => ({ label, value }));



const additionalEstateInfo = {
    fields: {
        estateType: dataTypes.ADDRESS,
    },
    validation: {
        estateType: false,
    }
};

const addressData = {
    fields: {
        typeOfRoad: { label: '', value: '' },
        province: { label: '', value: '' },
        population: { label: '', value: '' },
        roadName: '',
        numberStreet: '',
        another: '',
        postalCode: ''
    },
    validation: {
        typeOfRoad: false,
        province: false,
        population: false,
        roadName: false,
        numberStreet: false,
        postalCode: false
    }
};

const addRegCode = {
    fields: {
        cruIdufir: ''
    },
    validation: {
        cruIdufir: false
    }
};

const addRegData = {
    fields: {
        province: { label: '', value: '' },
        population: { label: '', value: '' },
        registerName: { label: '', value: '' },
        estateNumber: '',
        estateSection: '',
        estateBook: '',
        estateVolume: '',
        estateFolio: ''
    },
    validation: {
        province: false,
        population: false,
        registerName: false,
        estateNumber: false,
        estateSection: false,
        estateBook: false,
        estateVolume: false,
        estateFolio: false
    }
};

const LIVING_PLACE_DATA = {
    additionalEstateInfo: cloneDeep(additionalEstateInfo),
    address: cloneDeep(addressData),
    addRegCode: cloneDeep(addRegCode),
    addRegData: cloneDeep(addRegData)
};

const MAP_DATA = {
    garages: {
        field: 'garages', // string | cantidad de garajes agregados. Enviar solo en el endpoint de vivienda,
        default: ''
    },
    id: {
        field: 'id', // int | cuando el bien ya existe y se necesite actualizar info
        default: null
    },
    idtype: {
        field: 'estateType', // string | (CRU|REG|DIR) |tipo de info cruIdufir/regData/dirección
        default: dataTypes.ADDRESS
    },
    idufir: {
        field: 'cruIdufir', // string
        default: ''
    },
    populationId: {
        field: 'population', // integer | usar campo "value"
        default: null
    },
    postalCode: {
        field: 'postalCode', // string
        default: ''
    },
    provinceId: {
        field: 'province', // integer | usar "value"
        default: null
    },
    registerBook: {
        field: 'estateBook', // string
        default: ''
    },
    registerFincaNumber: {
        field: 'estateNumber', // string
        default: ''
    },
    registerFolio: {
        field: 'estateFolio', // string
        default: ''
    },
    registerId: {
        field: 'registerName',  // integer | usar "value"
        default: null
    },
    registerSection: {
        field: 'estateSection', // string
        default: ''
    },
    registerVolume: {
        field: 'estateVolume', // string
        default: ''
    },
    simpleNoteFlag: {
        field: null, // int | no usamos nota simple
        default: 0
    },
    storageRooms: {
        field: 'storageRooms', // string | cantidad de trasteros agregados. Enviar solo en el endpoint de vivienda
        default: ''
    },
    street: {
        field: 'roadName', // string
        default: ''
    },
    streetNumber: {
        field: 'numberStreet', //integer
        default: null
    },
    addressOthers: {
        field: 'another', // string
        default: ''
    },
    streetType: {
        field: 'typeOfRoad', // string | tipo de calle/via | usar "value"
        default: 'AA'
    },
    type: {
        field: '', //V|T|G | según la info que vaya en el endpoint (vivienda|trastero|garaje)
        default: 'V'
    },
    propertyType: {
        field: 'string',
        default: 'V'
    }
};

const fieldsByType = {
    IGNORE: [
        'id',
        'idtype',
        'type',
        'propertyType',
        'simpleNoteFlag'
    ],
    [dataTypes.CRU]: [
        'idufir',
    ],
    [dataTypes.REG_DATA]: [
        'populationId',
        'provinceId',
        'registerBook',
        'registerFincaNumber',
        'registerFolio',
        'registerId',
        'registerSection',
        'registerVolume'
    ],
    [dataTypes.ADDRESS]: [
        'garages',
        'storageRooms',
        'populationId',
        'provinceId',
        'postalCode',
        'street',
        'streetBlock',
        'streetNumber',
        'streetPlant',
        'streetStair',
        'streetType',
        'streetletter',
        'addressOthers'
    ],
};

module.exports = {
    addressData,
    addRegData,
    dataTypes,
    fieldsByType,
    text,
    LIVING_PLACE_DATA,
    TYPE_OF_ROADS,
    MAP_DATA
}
